// API =>
import backEnd from "../services/Api";

export const LocalCSRFReceiver = async () => {
    let csrf = document.cookie
        .split("; ")
        .find(row => row.startsWith("csrftoken="))
        ?.split("=")[1];

    if (!csrf) {
        try {
            await backEnd.get("users/get_csrf_token/"); 

            csrf = document.cookie
                .split("; ")
                .find(row => row.startsWith("csrftoken="))
                ?.split("=")[1];
        } catch (error) {
            console.error("خطا در دریافت CSRF:", error);
        }
    }

    return csrf;
};
